import * as React from 'react';
import BasicModal from '../Modal';
import { NormalButton } from 'components/atoms/Button';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { removeSubscribedTo, selectAuth } from 'features/auth/authSlice';
import Loader from 'components/atoms/loader';
import BackstagePrompt from 'views/DesktopViews/OtherProfilePage/ProfilePageBody/BackstagePrompt';
import { UserData } from 'interfaces/UserData.interface';
import { handleToggleSubscribe, handleTrialSubscribe } from 'APIs/utils';
import { Box } from '@mui/material';
import CopyToClickButton from 'components/atoms/Button/CopyToClipButton';
import { ACCESS_TOKEN } from 'constant';
import { toggleUnSubscribeUser } from 'APIs/UserDataApi';

interface ISubscriptionPriceModalProps {
  children: JSX.Element;
  transaction: boolean;
  loading: boolean;
  user?: Partial<UserData>;
  isSubscribed: boolean;
  setSubscribed: React.SetStateAction<any>;
  setTransaction: React.SetStateAction<any>;
  setLoading: React.SetStateAction<any>;
  setIsSubscribed: React.SetStateAction<any>;
  setError: React.SetStateAction<any>;
  price: string;
  subscribed: boolean;
}

const SubscribeModal = ({
  children,
  transaction,
  loading,
  user,
  isSubscribed,
  setSubscribed,
  setIsSubscribed,
  setLoading,
  setTransaction,
  setError,
  price,
  subscribed,
}: ISubscriptionPriceModalProps) => {
  const [open, setOpen] = React.useState(false);
  const [link, setLink] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const authState = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const handleClick = async () => {
    if (authState.id && window.ethereum && window.ethereum.isMetaMask) {
      user?.trialDuration && user?.numberOfSales && user.numberOfSales > 0
        ? handleTrialSubscribe(
            authState,
            user,
            setSubscribed,
            user.trialDuration
          )
        : handleToggleSubscribe(
            authState,
            setError,
            setTransaction,
            setLoading,
            setIsSubscribed,
            dispatch,
            false,
            price,
            user
          );
    } else {
      handleClosePrompt();
    }
  };

  const handleClosePrompt = () => {
    setLoading(false);
    setTransaction(false);
    setLink(true);
  };

  const getLink = () => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    return `${window.location.href}?transaction=true&&signin=${token}`;
  };

  const unsub = async () => {
    if (authState.subscribedTo) {
      const subId = authState.subscribedTo.find(
        sub => sub.from.id === authState.id && sub.to.id === user?.id
      );
      if (subId?.id) {
        await toggleUnSubscribeUser(subId?.id);
        dispatch(removeSubscribedTo(subId?.id));
        setSubscribed(false);
        setIsSubscribed(false);
      }
    }
  };

  return (
    <div>
      <span onClick={subscribed ? unsub : handleOpen}>{children}</span>
      <BasicModal open={open} handleClose={handleClose}>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <BackstagePrompt transaction={transaction} loading={loading}>
            <NormalButton
              sx={{
                width: '100%',
                maxWidth: '400px',
                minWidth: '300px',
                textTransform: 'uppercase',
              }}
              text={
                loading ? (
                  <Loader size="2" />
                ) : transaction ? (
                  'Waiting on block chain transaction'
                ) : user?.trialDuration &&
                  user?.numberOfSales &&
                  user.numberOfSales > 0 ? (
                  'Claim Trial'
                ) : (
                  'Subscribe With Metamask'
                )
              }
              color="yellow"
              onClick={handleClick}
              isDisabled={isSubscribed || transaction || loading}
            />
          </BackstagePrompt>
          <NormalButton
            sx={{
              width: '100%',
              maxWidth: '300px',
              minWidth: '300px',
              textTransform: 'uppercase',
            }}
            text={'Subscribe With Stripe'}
            isDisabled
          />
          {link && (
            <Box
              sx={{ width: '80%', mt: 2, color: 'white', textAlign: 'center' }}
            >
              <CopyToClickButton
                style={{ width: '100%', marginBottom: 5 }}
                text={getLink()}
              />
              Copy this link into MetaMask Browser to make transaction - or open
              on desktop with meta mask extension
            </Box>
          )}
        </Box>
      </BasicModal>
    </div>
  );
};

export default SubscribeModal;
